<template>
  <div class="">
    <div class="welcome-image d-flex justify-content-center">
      <img :src="company === 1 ? 'assets/img/logo.png' : 'assets/img/logo2.png'" alt="Selamat datang" style="max-width: 150px; max-height: 150px;">
    </div>
    <div class="container">
      <div class="page-header text-center">
        <div class="welcome-message col-lg-12">
          <h4 v-if="company === 1">Selamat Datang di <br>Content Management System PT. Fastana Logistik Indonesia!</h4>
          <h4 v-else>Selamat Datang di <br>Content Management System PT. Fastana Warehouse Indonesia!</h4>
        </div>
      </div>
    </div>
    <br>
    <div class="container-body">
      <div class="row justify-content-center">
        <div class="card-home" v-if="company === 1">
          <div class="card-title">
            Total Kendaraan
          </div>
          <div class="card-body">
            <h2>
              {{ totalVehicles }}
              <i class="bi bi-truck fs-2"></i>
            </h2>
            <button class="btn-home" @click="goToVehiclePage">
              <i class="bi bi-truck me-2 icon-home"></i><p class="text-home">Lihat Daftar Kendaraan</p>
            </button>
          </div>
        </div>
        <div class="card-home" v-if="company !== 1">
          <div class="card-title">
            Total Gudang
          </div>
          <div class="card-body">
            <h2>
              {{ totalGudang }}
              <i class="bi bi-truck fs-2"></i>
            </h2>
            <button class="btn-home" @click="goToGudang">
              <i class="bi bi-truck me-2 icon-home"></i><p class="text-home">Lihat Daftar Gudang</p>
            </button>
          </div>
        </div>
        <div class="card-home">
          <div class="card-title">
            Total Berita
          </div>
          <div class="card-body">
            <h2>
              {{ totalNews }}
              <i class="bi bi-newspaper fs-2"></i>
            </h2>
            <button class="btn-home" @click="goToNewsPage">
              <i class="bi bi-newspaper me-2 icon-home"></i><p class="text-home">Lihat Daftar Berita</p>
            </button>
          </div>
        </div>
        <div class="card-home">
          <div class="card-title">
            Total Pelamar
          </div>
          <div class="card-body">
            <h2>
              {{ totalAllApplicants }}
              <i class="bi bi-person fs-2"></i>
            </h2>
            <button class="btn-home" @click="goToApplicantPage">
              <i class="bi bi-person me-2 icon-home"></i><p class="text-home">Lihat Daftar Pelamar</p>
            </button>
          </div>
        </div>
        <div class="card-home">
          <div class="card-title">
            Total Lowongan
          </div>
          <div class="card-body">
            <h2>
              {{ totalAllCareers }}
              <i class="bi bi-briefcase fs-2"></i>
            </h2>
            <button class="btn-home" @click="goToCareerPage">
              <i class="bi bi-briefcase me-2 icon-home"></i> <p class="text-home">Lihat Daftar Lowongan</p>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row mt-4">
      <div class="col d-flex justify-content-center">
        <img src="assets/img/peta.png" alt="Tampilkan Gambar" style="max-width: 100%; max-height: 100%;">
      </div>
    </div> -->

  </div>
</template>

<script>
import vehicleController from '@/components/controllers/vehicleController/controller';
import newsController from '@/components/controllers/newsController/controller';
import applicantController from '@/components/controllers/applicantController/controller';
import careerController from '@/components/controllers/careerController/controller';
import gudangController from '@/components/controllers/gudangController/controller';
import { EventBus } from "@/eventBus";

export default {
  name: "WelcomePageNew",
  data () {
    return {
      company: null,
      totalVehicles: '',
      totalNews: '',
      totalAllApplicants: '',
      totalAllCareers: '',
      totalGudang: ''
    }
  },
  methods: {
    goToHomePage() {
      this.$router.push({ name: 'home' });
    },
    goToVehiclePage() {
      this.$router.push({ name: 'data-vehicles' });
    },
    goToNewsPage() {
      this.$router.push({ name: 'data-berita' });
    },
    goToApplicantPage() {
      this.$router.push({ name: 'data-applicants' });
    },
    goToCareerPage() {
      this.$router.push({ name: 'data-careers' });
    },
    goToGudang() {
      this.$router.push({ name: 'data-gudang' });
    },
    async GudangCount() {
      try {
        const company_id = this.company;
        const response = await gudangController.totalAllGudang('all', company_id);
        console.log(response);
        this.totalGudang = response.data;
        console.log(this.totalGudang);  
      } catch (error) {
        console.error('Error fetching vehicles:', error);
      }
    },
    async VehicleCount() {
      try {
        const query = 'all';
        const response = await vehicleController.totalAllVehicles(query);
        this.totalVehicles = response.count_vehicle[0].count;
        console.log(this.totalVehicles);
      } catch (error) {
          console.error('Error fetching vehicles:', error);
      }
    },
    async BeritaCount() {
      try {
          const company_id = this.company;
          const response = await newsController.totalAllNews('all', company_id);
          this.totalNews = response.data;
      } catch (error) {
          console.error('Error fetching news:', error);
      }
    },
    async ApplicantCount() {
      try {
          const company_id = this.company;
          const response = await applicantController.totalAllApplicants('all', company_id);
          this.totalAllApplicants = response.data;
      } catch (error) {
          console.error('Error fetching news:', error);
      }
    },
    async CareerCount() {
      try {
          const company_id = this.company;
          const response = await careerController.totalAllCareersActive('all', company_id);
          this.totalAllCareers = response.data;
      } catch (error) {
          console.error('Error fetching news:', error);
      }
    },
    onCompanyChange(newCompany) {
      this.company = newCompany;
    }
  },
  beforeDestroy() {
    EventBus.$off("companyChanged", this.onCompanyChange);
  },
  mounted() {
    this.company = JSON.parse(localStorage.getItem("company"));
    EventBus.$on("companyChanged", this.onCompanyChange);
    console.log(this.company);
    this.VehicleCount();
  },
  watch  :{
    company: {
      handler() {
        this.BeritaCount();
        this.ApplicantCount();
        this.CareerCount();
        this.GudangCount();
      }
    }
  }
}
</script>

<style scoped>
.welcome-container {
  display: flex;
  flex-direction: column;
  background-color: #f0f4f8;
  padding: 20px;
  box-sizing: border-box;
}

.welcome-message h4 {
  font-size: 1.5rem;
  color: #024999;
}

.welcome-message p {
  font-size: 1rem;
  margin: 15px 0;
}

button {
  padding: 8px 16px;
  font-size: 0.9rem;
  color: #fff;
  background-color: #024999;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #ffffff;
}

.welcome-image img {
  max-width: 90%;
  height: auto;
  margin-top: 20px;
}
</style>
